import {
  initIdentity,
  createRetentionProvider,
} from '@redbrickmedia/duplex.user-identity'
import { OpenFeature } from '@openfeature/web-sdk'
import { getCurrentTenant } from '../utils/tenants/getCurrentTenant'
import debug from '../utils/console'

const logger = debug.withTag('plugins:user-identity')

export default defineNuxtPlugin({
  name: 'user-identity',
  dependsOn: ['openfeature', 'user-segment', 'assertive'],
  setup: async () => {
    const { client } = await useOpenFeature()
    if (!client.getBooleanValue('enableUserIdentity', false)) {
      return
    }

    const { targetingKey } = OpenFeature.getContext()
    if (typeof targetingKey !== 'string' || !targetingKey) {
      logger.warn('No targetingKey available; skipping identity capture')
      return
    }

    const { accountId } = useAppConfig().adops.retention
    const provider = createRetentionProvider({ accountId })

    // Queue behind Assertive Yield so initIdentity's pbjs.mergeConfig runs after
    // AY has applied its own Prebid config (otherwise AY overwrites the merge).
    window.assertiveQueue = window.assertiveQueue || []
    window.assertiveQueue.push(() => {
      void initIdentity({
        userId: targetingKey,
        source: getCurrentTenant(),
        provider,
        sendToGAM: false,
      }).catch(() => logger.warn('user-identity init failed'))
    })
  },
})
